module.exports = __webpack_public_path__ + "img/countdown.50d318ef.png";